import React from 'react';
import { RegularMetricId } from '../../../../api/types-graphql';
import { ExternalChartComponentProps } from '../../../../common/components/data-viz-containers/common/types';
import { MultiMetricComparisonViz } from '../../../../common/components/data-viz-containers/multi-metric-comparison/MultiMetricComparisonViz';
import {
  MultiMetricComparisonVizConfig,
  MultiMetricComparisonVizViews,
} from '../../../../common/components/data-viz-containers/multi-metric-comparison/types';
import { defaultChartColors } from '../../../../common/components/ui-components/data-viz-ui/charts/common/common-chart-utils/common-chart-styles';
import { Languages } from '../../../../constants';
import { SingleValueTimeSelection } from '../../../../types';

interface MidCareerRecruitmentFunnelChartProps {
  timeSelection: SingleValueTimeSelection;
  externalProps: ExternalChartComponentProps;
}

const MID_CAREER_FILTER = `APPLICATION.CUSTOM_FILTER_1 = '中途'`;

export const MidCareerRecruitmentFunnelChart: React.FC<
  MidCareerRecruitmentFunnelChartProps
> = (props) => {
  const { timeSelection, externalProps } = props;

  const multiMetricConfig: MultiMetricComparisonVizConfig = {
    title: {
      [Languages.EN]: 'Recruitment Funnel',
      [Languages.JA]: '採用ファネル',
    },
    timeSelection,
    queries: [
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0252_2ApplicationsCount,
        },
        label: {
          [Languages.EN]: 'Applications',
          [Languages.JA]: '人事書類選考',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0256_1ApplicationsAtScreeningCount,
        },
        label: {
          [Languages.EN]: 'Screening',
          [Languages.JA]: '部門書類選考',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0260_1ApplicationsAt_1stInterviewCount,
        },
        label: {
          [Languages.EN]: '1st Interview',
          [Languages.JA]: '1次面接',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0264_1ApplicationsAt_2ndInterviewCount,
        },
        label: {
          [Languages.EN]: '2nd Interview',
          [Languages.JA]: '2次面接',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0268_1ApplicationsAtFinalInterviewCount,
        },
        label: {
          [Languages.EN]: 'Final Interview',
          [Languages.JA]: '3次面接',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0272_1ApplicationsAtOfferCount,
        },
        label: {
          [Languages.EN]: 'Offer',
          [Languages.JA]: '内定',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0276_1ApplicationsAtHiredCount,
        },
        label: {
          [Languages.EN]: 'Hired',
          [Languages.JA]: '入社',
        },
      },
    ],
    filters: MID_CAREER_FILTER,
    isHorizontal: true,
    chartColors: defaultChartColors,
  };

  return (
    <MultiMetricComparisonViz
      dataConfig={multiMetricConfig}
      selectedView={MultiMetricComparisonVizViews.BAR_CHART}
      externalProps={externalProps}
      persistenceKey="mid-career-recruitment-funnel-chart-v2"
    />
  );
};
